/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React from 'react';

// ours
import { GlyphLinkOut } from '@americanexpress/dls-react';
import Anchor from '../atomic/atoms/anchor/Anchor';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// styles
import styles from './DrawerIntro.module.scss';

interface DrawerIntroProps {
    header?: string;
    content: string | JSX.Element;
    learnMoreUrl?: string;
    learnMoreContent?: string | JSX.Element;
}

export default function DrawerIntro(props: DrawerIntroProps): JSX.Element {
    return (
        <div className="drawerSection">
            <div>
                {props.header && (
                    <Typography variant={TypographyVariants.HEADING_XS} className={styles.drawerIntroSubheading}>
                        {props.header}
                    </Typography>
                )}
                <Typography variant={TypographyVariants.SUBTEXT}>{props.content}</Typography>
            </div>
            {props.learnMoreUrl && props.learnMoreContent && (
                <Anchor
                    target="_blank"
                    rel="noopener noreferrer"
                    href={props.learnMoreUrl}
                    typographyProps={{ variant: TypographyVariants.SUBTEXT }}
                >
                    {props.learnMoreContent} {<GlyphLinkOut />}
                </Anchor>
            )}
        </div>
    );
}
